<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../assets/img/web/workshop/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">
            {{ titleName }}
            <span v-if="littleName || titleName != ''">-</span>
            {{ littleName }}


          </div>
          <div class="monitorWorshop" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
            <div style="display: flex;align-items: center;">
              <yi_data_select :type="'organization'" :ids.sync="orgId"> </yi_data_select>
              <el-link v-if="isEditingTemplate" @click="finishTemplateEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;">
                {{ $t("wanchengbianji") }}
              </el-link>
              <el-link v-else @click="showBoardEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;" icon="yicon yicon-pencil">
                {{ $t("bianjikanban") }}
              </el-link>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24 * (isEditingTemplate == true ? 2 : 1)" :row-height="gridRowHeihgt" :is-draggable="isEditingTemplate" :is-resizable="isEditingTemplate" :is-mirrored="false" :vertical-compact="false" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight * (isEditingTemplate == true ? 2 : 1) + 'px' }" style="overflow: hidden;">
          <grid-item @resized="resizedGrid" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component v-if="(!isEditingTemplate && item.y < 24) || isEditingTemplate" :cockpitData="cockpitData" :ref="'grid_' + item.i" v-bind:is="item.i" :orgId="orgId"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
    <el-dialog :show-close="true" :title="$t('kanbanshezhi')" :visible.sync="isShowBoardEdit" :close-on-click-modal="false" width="874px" append-to-body>
      <setting ref="setting"></setting>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowBoardEdit = false">{{ $t("quxiao") }}</el-button>
        <el-button size="mini" @click="
          $refs.setting.save();
        isShowBoardEdit = false;
        " type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from "vue-grid-layout";
import up from "@@/pages/web/monitor/cockpit/up";
import flow_sort from "@@/pages/web/monitor/cockpit/flow_sort";
import output_sort from "@@/pages/web/monitor/cockpit/output_sort";
import produce_data from "@@/pages/web/monitor/cockpit/produce_data";
import produce_progress from "@@/pages/web/monitor/cockpit/produce_progress";
import reason_sort from "@@/pages/web/monitor/cockpit/reason_sort";
import quota from "@@/pages/web/monitor/cockpit/quota";
import setting from "@@/pages/web/monitor/cockpit/setting";
export default {
  name: "web_monitor_cockpit_index",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    up: up,
    flow_sort: flow_sort,
    output_sort: output_sort,
    produce_data: produce_data,
    produce_progress: produce_progress,
    reason_sort: reason_sort,
    quota: quota,
    setting: setting,
  },

  data() {
    return {
      titleName: '',
      littleName: '',
      isEditingTemplate: false,
      isShowBoardEdit: false,
      orgId: this.store.state.organizations[0].id,
      cockpitData: {},
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: [],
    };
  },
  watch: {
    orgId(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getCockpit();
    },
  },
  created() {
    this.setLayout();

    this.timmer = setInterval(() => {
      this.getCockpit();
    }, 600000);
    this.getCockpit();
  },
  activated() {
    this.resize();
  },
  mounted() {
    /*   setInterval(() => {
         console.log(this.layout);
       }, 5000);*/
    this.resize();
    this.utils.event_hub.$on("SetLayoutCockpit", () => {
      this.setLayout();
    });
    this.utils.event_hub.$on("BeginEditCockpit", () => {
      this.isEditingTemplate = true;
      this.isShowBoardEdit = false;
    });
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    this.utils.event_hub.$off("SetLayoutCockpit");
    this.utils.event_hub.$off("BeginEditCockpit");

    if (this.timmer) {
      clearInterval(this.timmer);
    }
  },
  methods: {
    setLayout() {
      this.monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting["MONITOR_COCKPIT_HEADER_" + this.store.state.customer.id] != null) {
        this.titleName = this.monitorSetting["MONITOR_COCKPIT_HEADER_" + this.store.state.customer.id];
      } else {
        this.titleName = this.store.state.customer.shortName
      }
      if (this.monitorSetting["MONITOR_COCKPIT_CARD_TITLE_" + this.store.state.customer.id] != null) {
        this.littleName = this.monitorSetting["MONITOR_COCKPIT_CARD_TITLE_" + this.store.state.customer.id];
      } else {
        this.littleName = this.$t('jiashicang')
      }
      if (this.monitorSetting.MONITOR_COCKPIT_TEMPLATE == null) {
        this.monitorSetting.MONITOR_COCKPIT_TEMPLATE = "moren";
      }
      if (this.monitorSetting.MONITOR_COCKPIT_TEMPLATES == null) {
        this.monitorSetting.MONITOR_COCKPIT_TEMPLATES = {
          moren: [
            {
              x: 0,
              y: 0,
              w: 6,
              h: 12, //应该是6
              i: "up",
            },
            {
              x: 6,
              y: 0,
              w: 12,
              h: 12, //应该是6
              i: "quota",
            },
            {
              x: 18,
              y: 0,
              w: 6,
              h: 12,
              i: "produce_progress",
            },
            {
              x: 0,
              y: 12,
              w: 6,
              h: 12, //应该是6
              i: "reason_sort",
            },
            {
              x: 6,
              y: 12,
              w: 12,
              h: 12, //应该是6
              i: "produce_data",
            },
            {
              x: 18,
              y: 12,
              w: 6,
              h: 6, //应该是6
              i: "output_sort",
            },
            {
              x: 18,
              y: 18,
              w: 6,
              h: 6, //应该是6
              i: "flow_sort",
            },
          ],
        };
      }

      this.layout = this.monitorSetting.MONITOR_COCKPIT_TEMPLATES[this.monitorSetting.MONITOR_COCKPIT_TEMPLATE];
      this.$nextTick(() => {
        this.utils.event_hub.$emit("RESIZE");
      });
    },
    async getCockpit() {
      let response = await this.http.get("/web/report/page/quality_cockpit", {
        params: {
          orgId: this.orgId,
        },
      });
      this.cockpitData = response.data.extend;
    },
    showBoardEdit() {
      this.isShowBoardEdit = true;
      this.$nextTick(() => {
        this.$refs.setting.resetData();
      });
    },
    resizedGrid(i) {
      this.$refs["grid_" + i][0].resize();
    },
    finishTemplateEdit() {
      for (let i = 0; i < this.layout.length; i++) {
        let lay = this.layout[i];
        if (lay.y + lay.h > 24) {
          // this.utils.errorMessage(this.$t("zujianbuyunxuchaochupingmufanwei,qingtiaozheng"));
          // return;
        }
      }

      let monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
      monitorSetting.MONITOR_COCKPIT_TEMPLATES[this.monitorSetting.MONITOR_COCKPIT_TEMPLATE] = this.layout;
      localStorage.setItem("MONITOR_SETTING", JSON.stringify(monitorSetting));

      this.isEditingTemplate = false;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
      }, 500);
    },
  },
};
</script>
